import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DiscussionsMessagesService } from './discussions-messages.service';
import { DiscussionOperatorTypes, DiscussionsMessagesTypes } from '../discussion-properties';
import { bcEnums } from 'common/common/constants/boldchat-enums';

@Component({
  selector: 'app-discussions-messages',
  templateUrl: './discussions-messages.component.html',
  styleUrls: ['./discussions-messages.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class DiscussionsMessagesComponent {
  @Input() workItemId;
  @Input() operatorType;

  public types;

  constructor(private _discussionsMessagesService: DiscussionsMessagesService) {
    this.types = bcEnums.messageGroupTypes;
  }

  get discussionMessages() {
    return this._discussionsMessagesService.getMessages(this.workItemId);
  }

  public formatSystemMessage(message) {
    return this._discussionsMessagesService.formatSystemMessage(message);
  }

  public formatTimestamp(message) {
    const messages = message.messages;
    return this._discussionsMessagesService.formatTimestamp(messages[messages.length - 1].Created);
  }

  public getOperatorTypeKey(operatorType) {
    return this._discussionsMessagesService.getOperatorTypeKey(operatorType);
  }

  public getMessageTypeClass(operatorType, messageGroup) {
    if (this._isInbound(operatorType, messageGroup)) {
      return 'inbound-message';
    } else {
      return 'outbound-message';
    }
  }

  public getMessageTextTypeClass(operatorType, messageGroup) {
    if (this._isInbound(operatorType, messageGroup)) {
      return 'inbound-message-text';
    } else {
      return 'outbound-message-text';
    }
  }

  public getTimestampClass(operatorType, messageGroup) {
    if (this._isInbound(operatorType, messageGroup)) {
      return 'inbound-last-message';
    } else {
      return 'outbound-last-message';
    }
  }

  private _isInbound(operatorType, messageGroup) {
    return (operatorType === DiscussionOperatorTypes.OPERATOR) && (messageGroup === bcEnums.messageGroupTypes.HELPER) ||
      (operatorType === DiscussionOperatorTypes.HELPER) && (messageGroup === bcEnums.messageGroupTypes.OPERATOR);
  }

  public determineMessageClass(message) {
    if (message.MessageType === DiscussionsMessagesTypes.SYSTEM) {
      return 'system-message';
    } else {
      if (message.OperatorType === DiscussionOperatorTypes.HELPER) {
        return 'helper-message';
      } else {
        return 'operator-message';
      }
    }
  }
}
